var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1654 11.8773V13.6185C11.644 13.4342 11.0831 13.334 10.4987 13.334C7.73727 13.334 5.4987 15.5726 5.4987 18.334H3.83203C3.83203 14.6521 6.8168 11.6673 10.4987 11.6673C11.0742 11.6673 11.6327 11.7402 12.1654 11.8773ZM10.4987 10.834C7.7362 10.834 5.4987 8.59648 5.4987 5.83398C5.4987 3.07148 7.7362 0.833984 10.4987 0.833984C13.2612 0.833984 15.4987 3.07148 15.4987 5.83398C15.4987 8.59648 13.2612 10.834 10.4987 10.834ZM10.4987 9.16732C12.3404 9.16732 13.832 7.67565 13.832 5.83398C13.832 3.99232 12.3404 2.50065 10.4987 2.50065C8.65703 2.50065 7.16536 3.99232 7.16536 5.83398C7.16536 7.67565 8.65703 9.16732 10.4987 9.16732ZM15.4987 14.1673V11.6673H17.1654V14.1673H19.6654V15.834H17.1654V18.334H15.4987V15.834H12.9987V14.1673H15.4987Z",
    fill: "#037BC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/userPlus.f6bc1b34abaea48cf482229c1eabfd0e.svg";
export { ForwardRef as ReactComponent };